import { Grid } from "@mui/material";
import React from "react";
import { IMaterial, IMaterialGroup } from "../../interfaces";

export const MaterialLocation: React.FC<{ material?: IMaterial, materialGroup?: IMaterialGroup }> = ({
    material,
    materialGroup,
    ...props
}) => {

    const wrapperStyle = {
        width: '180px'
    }

    const idStyle = {
        justifyContent: 'space-between',
        borderBottom: '1px solid lightgrey'
    }

    const emptyMaterial: IMaterial = {
        partNumber: undefined,
        catalogueNumber: undefined,
        manufacturerNumber: undefined,
        serialNumber: undefined,
        vehicleNumber: undefined,
        unitNumber: undefined,
        porterbrookAssetNumber: undefined,
        unitOfQuantity: {},
        images: []
    }

    const identifierMaterial: IMaterial = materialGroup ? {
        ...emptyMaterial,
        partNumber: materialGroup.partNumber,
        catalogueNumber: materialGroup.catalogueNumber,
    } : material ? material : emptyMaterial;

    return (
        <>
            <Grid container sx={wrapperStyle}>
                <Grid container sx={idStyle} display={identifierMaterial.site?.value ? "auto" : "none"}>
                    <Grid item><small><em>Site</em></small> </Grid>
                    <Grid item> {identifierMaterial.site?.value}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.warehouse?.value ? "auto" : "none"}>
                    <Grid item><small><em>Warehouse</em></small> </Grid>
                    <Grid item>{identifierMaterial.warehouse?.value}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.rack ? "auto" : "none"}>
                    <Grid item><small><em>Rack</em></small> </Grid>
                    <Grid item>{identifierMaterial.rack}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.row ? "auto" : "none"}>
                    <Grid item><small><em>Row</em></small> </Grid>
                    <Grid item>{identifierMaterial.row}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.pallet ? "auto" : "none"}>
                    <Grid item><small><em>Pallet</em></small> </Grid>
                    <Grid item>{identifierMaterial.pallet}</Grid>
                </Grid>
            </Grid>
        </>
    );
}

